import React, { useState } from 'react';
import { AlertTriangle, Archive, Trash2, X } from 'lucide-react';
import { inventoryService } from '../../../services/inventoryService';

export default function ArchiveDeleteModal({ item, onClose, onDone }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleArchive = async () => {
    setLoading(true);
    setError('');
    try {
      await inventoryService?.archiveItem(item?.id, item?.tableSource);
      onDone?.('archived');
      onClose?.();
    } catch (e) {
      setError(e?.message || 'Erreur lors de l\'archivage');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    setError('');
    try {
      const hasUsage = await inventoryService?.checkItemUsage(item?.id, item?.tableSource);
      if (hasUsage) {
        setError('Cet article a été utilisé dans des ventes ou mouvements. Il sera archivé plutôt que supprimé.');
        setLoading(false);
        return;
      }
      await inventoryService?.deleteItem(item?.id, item?.tableSource);
      onDone?.('deleted');
      onClose?.();
    } catch (e) {
      setError(e?.message || 'Erreur lors de la suppression');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-slate-700">
          <h2 className="text-lg font-bold text-gray-900 dark:text-white">Archiver / Supprimer</h2>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex items-start gap-3 p-3 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-700 rounded-lg">
            <AlertTriangle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-yellow-800 dark:text-yellow-300">
                Article : {item?.name || item?.barrelType || item?.cartonType}
              </p>
              <p className="text-xs text-yellow-700 dark:text-yellow-400 mt-1">
                Si l'article a été utilisé dans des ventes ou mouvements, il sera archivé (non supprimé) pour conserver l'historique.
              </p>
            </div>
          </div>

          {error && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
              {error}
            </div>
          )}

          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={handleArchive}
              disabled={loading}
              className="flex items-center justify-center gap-2 px-4 py-3 bg-orange-100 text-orange-700 border border-orange-300 rounded-xl hover:bg-orange-200 text-sm font-medium disabled:opacity-50"
            >
              <Archive className="h-4 w-4" /> Archiver
            </button>
            <button
              onClick={handleDelete}
              disabled={loading}
              className="flex items-center justify-center gap-2 px-4 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 text-sm font-medium disabled:opacity-50"
            >
              <Trash2 className="h-4 w-4" /> Supprimer
            </button>
          </div>
          <button onClick={onClose} className="w-full px-4 py-2 text-sm border border-gray-300 dark:border-slate-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-slate-700">
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}
